export function state() {
	return {
		answer: null,
		error_message: "",
		is_required: false,
		is_displayed: false
	};
}
